import React, { useEffect } from 'react';

const DonatePage = () => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://cdn.razorpay.com/static/embed_btn/bundle.js'
    script.defer = true;
    script.id = 'razorpay-embed-btn-js'
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <div>
      <div className="text-center">
        <h1 className="text-3xl md:text-4xl my-6">Transforming lives, one step at a time.</h1>
        <h2 className="text-lg md:text-xl">Each contribution, no matter the size, is deeply valued!</h2>
        <p className="mt-3 text-gray-500 text-sm md:text-base">
          Your donation helps bring hope and change lives.
        </p>
      </div>

      <div
        className="razorpay-embed-btn mx-14 my-8 md:mx-[40%] "
        data-url="https://pages.razorpay.com/pl_QLfyISHIuQjbRM/view"
        data-text="Pay Now ❤️"
        data-color="#528FF0"
        data-size="large"
      ></div>

    <div className='text-center text-4xl font-bold flex flex-col justify-center items-center'>
        <h1>OR</h1> 
        <h2 className='text-gray-800 md:text-2xl text-lg'>You can donate directly via the Akoi Foundation QR.</h2>
        <img src="/assets/akoiQr2.png" alt="QR" className='w-80 md:w-96 h-full my-4 shadow' />
    </div>

    </div>
  );
};

export default DonatePage
